import React from "react";

function PolicyFooter() {
  return (
    <div className="pp-footer">
      <p>&copy; 2026 Food-Is. All rights reserved.</p>
      <p style={{ marginTop: "4px" }}>This privacy policy was last updated on July 3, 2026.</p>
    </div>
  );
}

export default PolicyFooter;
